(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elite-faq"] && !Shopify.designMode) return;
  try {
    
function initEliteFaq(){document.querySelectorAll('[data-elite-faq]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';let active='all';const search=root.querySelector('[data-faq-search]'),items=[...root.querySelectorAll('[data-faq-question]')],groups=[...root.querySelectorAll('[data-faq-group]')],buttons=[...root.querySelectorAll('[data-faq-filter]')];function filter(){const term=search.value.toLowerCase().trim();let count=0;items.forEach(item=>{const visible=(active==='all'||item.dataset.category===active)&&item.dataset.search.toLowerCase().includes(term);item.hidden=!visible;if(visible)count++});groups.forEach(group=>{group.hidden=![...group.querySelectorAll('[data-faq-question]')].some(item=>!item.hidden)});root.querySelector('[data-faq-count]').textContent=count;root.querySelector('[data-faq-empty]').hidden=count>0}search.addEventListener('input',filter);buttons.forEach(button=>button.addEventListener('click',()=>{active=button.dataset.faqFilter;buttons.forEach(btn=>btn.setAttribute('aria-pressed',String(btn===button)));filter()}));filter()})}initEliteFaq();document.addEventListener('shopify:section:load',initEliteFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-hid-story"] && !Shopify.designMode) return;
  try {
    
function showOemSeriesCover() {
  if (!document.querySelector('[data-hid-enhanced]') || new URLSearchParams(window.location.search).has('variant')) return;
  const cover = document.querySelector('button.slideshow-controls__thumbnail img[src*="elite-leds-oem-hid-led-main.png"]');
  if (cover) cover.closest('button').click();
}
if (document.readyState === 'complete') showOemSeriesCover();
else window.addEventListener('load', showOemSeriesCover, { once: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-homepage"] && !Shopify.designMode) return;
  try {
    
function initAmirVideo(scope) {
  scope.querySelectorAll('.eh-amir-video').forEach(video => {
    if (video.dataset.ready) return;
    video.dataset.ready = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      video.muted = true;
      video.play().catch(() => {});
      observer.disconnect();
    }, { threshold: 0.35 });
    observer.observe(video);
  });
}
initAmirVideo(document);
document.addEventListener('shopify:section:load', event => initAmirVideo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-led-conversion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('[data-elc-select]'))return;const card=event.target.closest('.elc-card');const link=card.querySelector('[data-elc-link]');if(link)link.href=event.target.value;const artLink=card.querySelector('.elc-card-art');if(artLink)artLink.href=event.target.value;const option=event.target.selectedOptions[0];const price=card.querySelector('[data-elc-price]');if(price)price.textContent=option.dataset.price;const image=card.querySelector('.elc-card-art img');if(image&&option.dataset.image){image.src=option.dataset.image;image.removeAttribute('srcset');image.alt=option.textContent.trim();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-project-gallery"] && !Shopify.designMode) return;
  try {
    
function initializeEliteGalleries(){
document.querySelectorAll('.elite-gallery').forEach(root=>{
if(root.dataset.initialized)return;root.dataset.initialized='true';
let category='all';const search=root.querySelector('[data-gallery-search]');const cards=[...root.querySelectorAll('[data-gallery-card]')];
function filter(){let count=0;const term=search.value.toLowerCase().trim();cards.forEach(card=>{const match=(category==='all'||card.dataset.category===category||card.dataset.secondary===category)&&card.dataset.search.toLowerCase().includes(term);card.hidden=!match;if(match)count++;});root.querySelector('[data-gallery-count]').textContent=count+' '+root.querySelector('[data-gallery-count-label]').textContent;root.querySelector('[data-gallery-empty]').hidden=count>0;}
root.querySelectorAll('[data-gallery-filter]').forEach(button=>button.addEventListener('click',()=>{category=button.dataset.galleryFilter;root.querySelectorAll('[data-gallery-filter]').forEach(b=>{const active=b===button;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active));});filter();}));search.addEventListener('input',filter);filter();
const dialog=root.querySelector('dialog');const media=root.querySelector('[data-gallery-media]');let opener;
root.querySelectorAll('[data-gallery-open]').forEach(button=>button.addEventListener('click',()=>{opener=button;media.replaceChildren();root.querySelector('[data-gallery-title]').textContent=button.dataset.title;const cover=button.querySelector('img');const img=document.createElement('img');img.src=cover.currentSrc||button.dataset.image;img.alt=button.dataset.title;media.append(img);if(button.dataset.extra){const extra=document.createElement('img');extra.src=button.dataset.extra;extra.alt=button.dataset.title;extra.loading='lazy';media.append(extra);}if(button.dataset.video){const video=document.createElement('video');video.src=button.dataset.video;video.controls=true;video.playsInline=true;video.preload='none';video.poster=img.src;media.append(video);}dialog.showModal();}));
root.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});dialog.addEventListener('close',()=>{media.querySelectorAll('video').forEach(v=>v.pause());media.replaceChildren();if(opener)opener.focus();});
});
}
initializeEliteGalleries();document.addEventListener('shopify:section:load',initializeEliteGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
